import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import Link from "../../Link/Link/Link.js";
/* empty css               */
const LinkGroup = ({ className, links }) => {
  if (!links?.length) return null;
  return /* @__PURE__ */ React.createElement("ul", { className: classnames("link-group", className) }, links.map(({ icon, label, url, ...rest }) => /* @__PURE__ */ React.createElement("li", { key: label, className: "link-group__item" }, /* @__PURE__ */ React.createElement(Link, { url, className: "link-group__link", ...rest }, icon && /* @__PURE__ */ React.createElement(Icon, { className: "link-group__icon", name: icon, width: 32, height: 32 }), /* @__PURE__ */ React.createElement(Text, { className: "link-group__text", component: "span" }, label), /* @__PURE__ */ React.createElement(Icon, { className: "link-group__icon link-group__icon--arrow", name: "chevron-right" })))));
};
export {
  LinkGroup as default
};
//# sourceMappingURL=LinkGroup.js.map
